// 1黑料网 首页专题合集内容（静态展示数据）
export const navItems = [
  { label: '今日热度', anchor: '#rank' },
  { label: '热议话题', anchor: '#topics' },
  { label: '重磅合集', anchor: '#featured' },
  { label: '精选大全', anchor: '#library' },
  { label: '大盘点', anchor: '#digest' },
];

export const heroTags = [
  '顶流塌房',
  '直播翻车',
  '人设崩塌',
  '综艺名场面',
  '饭圈热战',
  '选秀黑幕',
  '代言割席',
  '偷逃税',
];

export const heatRank = [
  { rank: 1, title: '男团塌房"实锤时间线"刷屏', type: '偶像', heat: 98, trend: '+9', up: true },
  { rank: 2, title: '顶流翻车前的最后一场直播', type: '直播', heat: 95, trend: '+15', up: true },
  { rank: 3, title: '选秀"黑幕剧本"再度被翻出', type: '综艺', heat: 92, trend: '-3', up: false },
  { rank: 4, title: '新晋主播人设崩塌合集', type: '主播', heat: 88, trend: '+22', up: true },
  { rank: 5, title: '代言"连夜割席"名单盘点', type: '商务', heat: 85, trend: '+7', up: true },
  { rank: 6, title: '综艺后期"剪辑翻车"名场面', type: '综艺', heat: 82, trend: '+4', up: true },
  { rank: 7, title: '饭圈应援"集资去向"争议', type: '饭圈', heat: 79, trend: '+11', up: true },
  { rank: 8, title: '隐婚生子传闻发酵全过程', type: '八卦', heat: 76, trend: '+18', up: true },
];

export const topicGroups = [
  {
    name: '人物向',
    tags: ['顶流塌房', '翻车', '人设崩塌', '立人设', '回锅肉', '隐婚生子', '神隐退圈', '代播危机'],
  },
  {
    name: '事件向',
    tags: ['直播翻车', '集资争议', '连夜割席', '合同纠纷', '偷逃税', '阴阳合同', '录音门', '对簿公堂'],
  },
  {
    name: '综艺向',
    tags: ['剧本感', '剪辑争议', '神级名场面', '复活赛', '导师互呛', '后台爆料', '临场翻车'],
  },
  {
    name: '大盘向',
    tags: ['月度盘点', '半年度合集', '年度榜单', '人物志', '流量大战', '番位之争', '全网热榜'],
  },
];

export const featuredRoundups = [
  {
    kicker: '重磅 · 年度大合集',
    title: '顶流塌房全记录',
    desc: '从高光到崩塌，一条条热搜背后的实锤时间线被逐帧复盘：谁在反复横跳、谁在深夜道歉，那些被连夜删除的言论，都留在这一页大合集里。',
    meta: '收录 126 条动态',
    image: 'https://readdy.ai/api/search-image?query=silhouette%20of%20a%20lone%20figure%20standing%20backlit%20in%20harsh%20crimson%20rim%20light%20against%20a%20wall%20of%20white%20camera%20flash%20bursts%20and%20phone%20screens%20at%20night%2C%20blurred%20crowd%20motion%2C%20deep%20black%20background%20with%20red%20highlights%2C%20cinematic%20noir%2C%20mysterious%20identity%20concealed%20in%20shadow%2C%20breaking%20news%20editorial%20portrait%2C%20high%20contrast%20dramatic%20lighting%2C%20vertical%20magazine%20cover&width=800&height=1000&seq=feat-01&orientation=portrait',
  },
  {
    kicker: '名场面 · 名场面合集',
    title: '综艺翻车名场面大全',
    desc: '那些让弹幕瞬间爆炸的瞬间：导师当场变脸、选手临场断电、剪辑把"翻车"剪成了经典。几十个名场面按出圈度排序，一页看个够。',
    meta: '收录 88 段高光',
    image: 'https://readdy.ai/api/search-image?query=empty%20grand%20television%20studio%20stage%20at%20night%20with%20a%20single%20broken%20overhead%20spotlight%20swinging%2C%20fallen%20microphone%20stand%20and%20scattered%20script%20paper%20on%20glossy%20floor%2C%20long%20dramatic%20shadows%2C%20deep%20charcoal%20with%20warm%20amber%20red%20accent%20glow%2C%20cinematic%20suspense%20mood%2C%20dark%20luxurious%20minimal%20editorial%20photography%2C%20vertical%20composition&width=800&height=1000&seq=feat-02&orientation=portrait',
  },
  {
    kicker: '内幕 · 深度合集',
    title: '饭圈热战背后的利益地图',
    desc: '应援集资去向成谜、数据打投一夜暴涨、同框即开战。这场热闹背后，是谁在推波助澜？一份带时间线的利益关系地图，一次讲清。',
    meta: '梳理 34 条线索',
    image: 'https://readdy.ai/api/search-image?query=tight%20crowd%20of%20raised%20hands%20with%20glowing%20smartphone%20screens%20seen%20from%20behind%20at%20a%20dark%20arena%2C%20many%20small%20bright%20screens%20lighting%20the%20darkness%20in%20warm%20white%20and%20red%20tones%2C%20anonymous%20silhouette%20crowd%2C%20sense%20of%20intense%20collective%20reaction%20and%20debate%2C%20dark%20editorial%20social%20observation%20photography%2C%20cinematic%20depth%2C%20vertical%20magazine%20cover&width=800&height=1000&seq=feat-03&orientation=portrait',
  },
];

export const roundups = [
  {
    title: '选秀 & 舞台争议全盘点',
    tag: '综艺',
    desc: '从"剧本感"到"剪辑论"，一场选秀背后的操作手册被逐集拆解。',
    image: 'https://readdy.ai/api/search-image?query=backstage%20dressing%20room%20wall%20covered%20with%20glossy%20posters%20and%20peeling%20paper%2C%20makeup%20mirror%20with%20warm%20bulbs%2C%20scattered%20masks%20and%20props%20on%20counter%2C%20mysterious%20silhouette%20partly%20out%20of%20frame%2C%20dark%20moody%20editorial%2C%20crimson%20and%20amber%20accent%20lighting%2C%20investigation%20vibe%2C%20horizontal%20composition&width=800&height=600&seq=grid-01&orientation=landscape',
  },
  {
    title: '直播间人设崩塌档案',
    tag: '直播',
    desc: '滤镜背后的真实切片：人设立得越满，翻车来得越快。',
    image: 'https://readdy.ai/api/search-image?query=live%20streamer%20style%20dark%20neon%20lit%20desk%20with%20ring%20light%2C%20phone%20on%20tripod%2C%20scattered%20notes%20and%20headphones%2C%20only%20hands%20visible%20tapping%20keyboard%2C%20surveillance%20editorial%20mood%2C%20deep%20charcoal%20with%20warm%20red%20glow%2C%20cinematic%2C%20horizontal%20composition&width=800&height=600&seq=grid-02&orientation=landscape',
  },
  {
    title: '主播黑历史大合集',
    tag: '主播',
    desc: '旧账号、旧言论、旧剪辑，一件件被翻出，拼出一张完整的旧照。',
    image: 'https://readdy.ai/api/search-image?query=hooded%20person%20silhouette%20in%20front%20of%20towering%20wall%20of%20social%20feeds%20projected%20as%20blurred%20glowing%20text%20cascades%20downward%2C%20sense%20of%20collapsing%20image%20and%20public%20debate%2C%20deep%20black%20background%2C%20warm%20crimson%20glow%2C%20editorial%20concept%20photography%2C%20horizontal%20composition&width=800&height=600&seq=grid-03&orientation=landscape',
  },
  {
    title: '代言连夜割席名单',
    tag: '商务',
    desc: '一句话引发的连锁反应：品牌连夜发声明，解约名单一次列全。',
    image: 'https://readdy.ai/api/search-image?query=back%20view%20of%20public%20hearing%20room%20filled%20with%20anonymous%20seated%20figures%2C%20dark%20wooden%20benches%2C%20one%20bright%20document%20highlighted%20on%20desk%20with%20red%20stamp%2C%20dramatic%20top%20light%2C%20sense%20of%20evidence%20and%20verdict%2C%20cinematic%20dark%20editorial%20photography%2C%20horizontal%20composition&width=800&height=600&seq=grid-04&orientation=landscape',
  },
  {
    title: '剧宣 & 番位大战',
    tag: '影视',
    desc: '海报顺序、官微文案、红毯站位，每处细节都能点燃一场大战。',
    image: 'https://readdy.ai/api/search-image?query=glass%20trophy%20and%20gold%20laurel%20on%20black%20reflective%20surface%20with%20a%20visible%20crack%20running%20through%20the%20glass%2C%20one%20fallen%20trophy%20lying%20broken%20under%20a%20spotlight%2C%20deep%20shadows%20warm%20amber%20rim%20light%2C%20symbolism%20of%20rising%20and%20falling%20stardom%2C%20editorial%20still%20life%20photography%2C%20horizontal%20composition&width=800&height=600&seq=grid-05&orientation=landscape',
  },
  {
    title: '杂志 & 封面乌龙集',
    tag: '娱乐',
    desc: '修过头、排错位、临时换封，封面背后的每一次乌龙都被记录在册。',
    image: 'https://readdy.ai/api/search-image?query=smoke%20filled%20press%20conference%20podium%20with%20a%20wall%20of%20raised%20microphones%20and%20an%20unattended%20empty%20chair%2C%20single%20red%20podium%20light%20glowing%2C%20mysterious%20unanswered%20tension%2C%20dark%20charcoal%20editorial%20photography%2C%20cinematic%20composition%2C%20horizontal&width=800&height=600&seq=grid-06&orientation=landscape',
  },
];

export const digests = [
  {
    date: '2026.09',
    phase: '本月新料',
    title: '九月瓜田：直播与舞台的连环爆',
    summary: '进入九月，直播与综艺两大战场轮番引爆：从直播间里失控的几分钟，到舞台上那一句没来得及收的话，本月的瓜几乎都长在"现场"。一条条按热度串起来，给你一版不漏的九月速览。',
    image: 'https://readdy.ai/api/search-image?query=old%20fashioned%20tape%20recorder%20and%20scattered%20cassette%20tapes%20on%20worn%20desk%20under%20a%20single%20desk%20lamp%2C%20film%20noir%20detective%20mood%2C%20warm%20amber%20light%20and%20deep%20shadow%2C%20investigation%20archive%20editorial%20photography%2C%20cinematic%2C%20portrait%20composition&width=600&height=800&seq=dig-01&orientation=portrait',
  },
  {
    date: '2026.08',
    phase: '暑期复盘',
    title: '八月"瓜田"收官盘点',
    summary: '整个八月堪称全年热度峰值：一场场从早到晚的连续剧，一群又一群连夜出动的评论区。我们把八月最喧闹的几十个片段归档成册，回看那一个月到底谁在霸榜、谁在隐身。',
    image: 'https://readdy.ai/api/search-image?query=newspaper%20clippings%20pinned%20on%20corkboard%20connected%20by%20red%20threads%20forming%20a%20network%2C%20evidence%20wall%20investigation%20mood%2C%20warm%20lamp%20light%2C%20dark%20moody%20editorial%20photography%2C%20cinematic%20depth%2C%20portrait%20composition&width=600&height=800&seq=dig-02&orientation=portrait',
  },
  {
    date: '2026.07',
    phase: '人物志',
    title: '半年人物志：谁立了最厚的墙',
    desc: '',
    summary: '上半年落幕，我们把聚光灯重新打回每个人身上：谁在反复立人设，谁在深夜删动态，谁一句话点燃全网。半年人物志按事件密度逐一排座，看谁的高光与翻车一样密集。',
    image: 'https://readdy.ai/api/search-image?query=sealed%20cardboard%20archive%20box%20with%20red%20confidential%20stamp%20and%20manila%20folders%20stacked%2C%20single%20dramatic%20spotlight%2C%20deep%20shadow%2C%20archival%20investigation%20editorial%20photography%2C%20dark%20moody%20cinematic%2C%20portrait%20composition&width=600&height=800&seq=dig-03&orientation=portrait',
  },
  {
    date: '2026',
    phase: '年度盘点',
    title: '年度"反转"时刻榜',
    summary: '看热闹也看门道：这一年有太多"先骂后道歉、先捧后塌"的反转。我们把每次立场对调的关键节点单独拎出来，做成一张可回放的年度反转时刻榜。',
    image: 'https://readdy.ai/api/search-image?query=typewriter%20with%20half%20typed%20page%20and%20a%20glass%20of%20water%20under%20moody%20amber%20lamp%2C%20room%20for%20uncertainty%20and%20rumor%2C%20film%20noir%20editorial%20photography%2C%20deep%20black%20shadows%2C%20cinematic%20warm%20light%2C%20portrait%20composition&width=600&height=800&seq=dig-04&orientation=portrait',
  },
];

export const themes = [
  { name: '偶像', en: 'IDOL', desc: '塌房 / 立人设 / 打投', count: '2.4k' },
  { name: '综艺', en: 'SHOW', desc: '名场面 / 剪辑 / 剧本', count: '1.8k' },
  { name: '主播', en: 'STREAM', desc: '直播 / 人设 / 带货', count: '1.2k' },
  { name: '饭圈', en: 'FANDOM', desc: '集资 / 数据 / 应援', count: '986' },
  { name: '商务', en: 'BIZ', desc: '代言 / 割席 / 翻车', count: '742' },
  { name: '影视', en: 'FILM', desc: '番位 / 剧宣 / 乌龙', count: '631' },
];

export const footerLinks = [
  { title: '栏目导航', links: ['今日热度榜', '热议话题墙', '重磅专题合集', '精选内容大全', '月度大盘点'] },
  { title: '内容板块', links: ['偶像·人物向', '综艺·名场面', '主播·直播间', '饭圈·热战', '商务·割席录'] },
  { title: '关于本站', links: ['站点说明', '内容收录规则', '侵权投诉', '版权声明', '联系合作'] },
];